import { createContext, useContext, useEffect, useState } from "react";
import { PREFETCH_TYPES } from "client/services/consts";

const BACKGROUND_IMAGE_BOOK_A_MEETING = "https://images.typeform.com/images/Aw2xNHE6PiND/image/default";
const BACKGROUND_IMAGE_PHONE_CALL = "https://images.typeform.com/images/6NuLbnPVhJxy/image/default";
const MONDAY_LOGO = "https://images.typeform.com/images/2GR8rmBChTYm";

const STATIC_ASSETS_HREFS = [BACKGROUND_IMAGE_BOOK_A_MEETING, BACKGROUND_IMAGE_PHONE_CALL, MONDAY_LOGO];

const PREFETCHED_DOMAINS = ["https://form.typeform.com"];
const PRECONNECT_DOMAINS = PREFETCHED_DOMAINS;

const PrefetchedTypeformAssetsContext = createContext("PrefetchedTypeformAssets");

export const PrefetchTypeformAssetsProvider = (props) => {
  const { children } = props;
  const [prefetchedTypeformAssetsLinks, setPrefetchedTypeformAssetsLinks] = useState([]);

  useEffect(() => {
    const setData = async () => {
      const typeformAssetsLinks = [];
      // dns prefetches
      PREFETCHED_DOMAINS.forEach((href) => {
        typeformAssetsLinks.push({ type: PREFETCH_TYPES.DNS_PREFETCH, href });
      });

      // pre-connects
      PRECONNECT_DOMAINS.forEach((href) => {
        typeformAssetsLinks.push({ type: PREFETCH_TYPES.PRECONNECT, href });
      });

      // static assets
      STATIC_ASSETS_HREFS.forEach((href) => {
        typeformAssetsLinks.push({ type: PREFETCH_TYPES.PREFETCH, href });
      });

      setPrefetchedTypeformAssetsLinks(typeformAssetsLinks);
    };

    setData();
  }, []);

  return (
    <PrefetchedTypeformAssetsContext.Provider value={prefetchedTypeformAssetsLinks}>
      {children}
    </PrefetchedTypeformAssetsContext.Provider>
  );
};

export const usePrefetchedTypeformAssets = () => {
  const prefetchedTypeformAssetsLinks = useContext(PrefetchedTypeformAssetsContext);

  return prefetchedTypeformAssetsLinks;
};
